import React from "react";
import EsquemaSetab from "./components/EsquemaSetab";
import "./index.css"
function App() {
    return (
        <div  style={{padding:0,margin:0,width:'100%', heigth:'100%', background:'#202020'}}>
            <div style={{width:'auto', heigth:'6%', padding:'0% 10% 0% 10%', background:'#771139'}}>
                <span><p id='titesq'>Esquema del Sistema Educativo Estatal</p></span>
                <span><p id='subtitesq'>Cifras de Inicio de Cursos 2025-2026</p></span>
            </div>
            <div style={{width:'auto', heigth:'86%', padding:0, margin:0, background:'#efefef'}}>
                <EsquemaSetab/>
            </div>
            <div style={{width:'auto', heigth:'auto',background:'#efefef', fontSize:12, padding:'0.1% 0 0.1% 1%'}}>
                <table>
                    <tbody>
                        <tr>
                            <td align="left"><a><b>Nota:</b> La cuantificación de escuelas en secundaria,media superior y formación para el trabajo, está expresada mediante los turnos que ofrece un mismo inmueble; y en superior de acuerdo a las facultades o divisiones académicas de una misma Institución.</a></td>                            
                        </tr>
                        <tr>
                            <td align="left"><a style={{marginLeft: '34px'}}>No están incluidos los servicios de CAM en los de educación básica a cargo de la SETAB.</a></td>
                        </tr>
                        <tr>
                            <td align="left"><a><b>Fuente:</b> Estadística Básica del Sistema Educativo Estatal a Inicio de Cursos 2025-2026.</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default App;